/// <reference path="../../setup/_references.ts" />
module onvio.clientDashboard {
    'use strict';

    /**
     * Container for the preference endpoint
     */
    export interface IPreferences {
        id: string;
        application: string;
        category: string;
        value: any;
    }

    export class PreferenceService {

        static $inject = [
            '$q',
            '$http'
        ];

        constructor(
            private $q: ng.IQService,
            private $http: ng.IHttpService
        ) { }

        /**
         * Load user preferences for the client dashboard
         * @param application
         * @param category
         */
        public loadPreferences(application: string, category: string):ng.IPromise<any> {
            var deferred = this.$q.defer<void>();
            var url = '/api/profiles/v1/preferences?application=<app>&category=<cat>'
                .replace('<app>', application)
                .replace('<cat>', category);
            this.$http.get(url).then((response: any) => {
                deferred.resolve(response.data[0]);
            });
            return deferred.promise;
        }

        /**
         * Update the client id in the user preferences
         * @param preference
         */
        public storePreference(preferences: IPreferences): ng.IPromise<any> {
            // if we have an id, then this is a put (update)
            if (preferences.id) {
                let url = '/api/profiles/v1/preferences/<preferenceid>'
                    .replace('<preferenceid>', preferences.id);
                return this.$http.put<ClientDashboardPreferences>(url, preferences);
            } else {
                // if we don't have an id, then this is a post (add)
                let url = '/api/profiles/v1/preferences';
                return this.$http.post<ClientDashboardPreferences>(url, preferences);
            }
        }
    }

    angular.module('onvio.clientDashboard.PreferenceService', [])
        .service('onvio.clientDashboard.PreferenceService', PreferenceService);
}
